import { createSlice } from "@reduxjs/toolkit";
import httpService from "../services/api";
import { getRequestUsers, getPutUserRequest, getRequestDeleteUser } from "../services/users-requests";

import { uiActions } from "./ui-slice";

const usersSlice = createSlice({
  name: "users",
  initialState: { users: [], selected: undefined },
  reducers: {
    setUsers(state, action) {
      state.users = action.payload;
    },
    setSelected(state, action) {
      state.selected = state.users.find((u) => u.id === action.payload);
    },
    updateUser(state, action) {
      const user = state.users.find((u) => u.email === action.payload.email);
      user.login = action.payload.login;
      user.role = action.payload.role;
      user.isActive = action.payload.isActive;
      state.selected = user;
    },
    deleteUser(state, action) {      
      state.users = state.users.filter(u => u.id !== action.payload);      
    },
  },
});

export const usersActions = usersSlice.actions;

export const fetchUsers = () => {
  return async (dispatch) => {
    const getUsers = async () =>
      await httpService.fetchRequest(getRequestUsers());

    dispatch(uiActions.setUsersLoading(true));
    try {
      const users = await getUsers();
      dispatch(usersActions.setUsers(users));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    } finally {
      dispatch(uiActions.setUsersLoading(false));
    }
  };
};

export const updateUser = (userData) => {
  return async (dispatch) => {
    const putUser = async (data) =>
      await httpService.fetchRequest(getPutUserRequest(data));

    try {
      await putUser(userData);
      dispatch(usersActions.updateUser(userData));
      dispatch(uiActions.enqueNotification({
        message: "User updated",
        variant: "success"
      }));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export const deleteUser = (id) => {
  return async (dispatch) => {
    try {
      await httpService.fetchRequest(getRequestDeleteUser(id));
      dispatch(usersActions.deleteUser(id));
      dispatch(usersActions.setSelected(null));
      dispatch(uiActions.enqueNotification({
        message: "User deleted",
        variant: "success"
      }));
    } catch (error) {
      dispatch(uiActions.enqueErrorNotification(error));
    }
  };
};

export default usersSlice.reducer;
